import React from 'react';
import Context from '../Utilities';

const { Fragment } = window.wp.element;

function Question1() {
    return (
        <div id="question1" className="questions">
            <div className="question">
                <p>
                    Would you share your own opinion of Trump with this group?
                </p>
            </div>
            <div className="image">
                <img
                    src="https://assets.pewresearch.org/interactives/politics/2019/dinner-party/Path_none/Path_none.png"
                    alt="Illustration of four dinner guests sitting at a table."
                />
            </div>
            <div className="options">
                <Context.Consumer>
                    {({ toggleShare, share }) => {
                        return (
                            <Fragment>
                                <button
                                    className="ui button"
                                    id="Share"
                                    onClick={e => toggleShare(e)}
                                >
                                    Yes, I would share my views
                                </button>
                                <button
                                    className="ui button"
                                    id="NotShare"
                                    onClick={e => toggleShare(e)}
                                >
                                    No, I would avoid sharing my views
                                </button>
                            </Fragment>
                        );
                    }}
                </Context.Consumer>
            </div>
        </div>
    );
}

export default Question1;
